import { SchemaPlugin } from '@common/prosemirror/model/schema-plugin';
import { nodeToDOM } from '@common/util/schema';
import { NodeSpec } from 'prosemirror-model';

/**
 * ParagraphSchemaPlugin
 */
export class ParagraphSchemaPlugin extends SchemaPlugin {
  nodes = {
    paragraph: {
      group: 'block',
      linkBucket: 'paragraph',
      content: 'inline*',
      parseDOM: [{ tag: 'p' }],
      tagName: 'p',
      toDOM(node) { return nodeToDOM(node); }
    }
  } satisfies Record<string, NodeSpec>;
}
